import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "cm-theme";
type Theme = "dark" | "light";

function getInitial(): Theme {
  if (typeof window === "undefined") return "dark";
  const stored = window.localStorage.getItem(STORAGE_KEY);
  if (stored === "light" || stored === "dark") return stored;
  // Default: dark (operativa de jornadas largas).
  return "dark";
}

function applyTheme(theme: Theme) {
  const root = document.documentElement;
  if (theme === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

/**
 * Theme hook con persistencia localStorage.
 *
 * Para evitar flicker en boot, en `index.html` se hace una pre-aplicación
 * mínima del theme via inline script (ver index.html). Este hook
 * sincroniza el estado React con el class del <html>.
 */
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(getInitial);

  useEffect(() => {
    applyTheme(theme);
    window.localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((current) => (current === "dark" ? "light" : "dark"));
  }, []);

  return { theme, toggle, isDark: theme === "dark" };
}
